// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"218":"51f614aa","525":"d1a18177","654":"d1a18177"}[chunkId] + ".chunk.css";
};